module.exports = __webpack_public_path__ + "img/sciencepage4.19cbb037.png";